import { isCancel } from 'axios'
import { authenticateDevice } from './auth'

const successHandler = response => {
  return response
}

const errorHandler = error => {
  const unauthorized = error?.response?.status === 401
  const invalidToken = error?.response?.data?.error === 'invalid_token'

  if (unauthorized && invalidToken) {
    authenticateDevice()
  }

  if (!isCancel(error)) {
    // TODO: add toast or something else
    // toast.error('Something went wrong.')
  }

  return Promise.reject(error)
}

const responseInterceptors = [successHandler, errorHandler]

export default responseInterceptors
